<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon points="11,1.7 10.3,1 6,5.3 1.7,1 1,1.7 5.3,6 1,10.3 1.7,11 6,6.7 10.3,11 11,10.3 6.7,6" />
</svg>
</template>